import React, { useState, useEffect } from 'react'
import Drawer from 'components/Drawer'
import { COLORS } from 'theme'
import InfoCards from 'components/InfoCards'
import Internship from 'components/icons/Internship'
import { StyledTabs } from 'components/TabsPaneStyles'
import {
  CardRow,
  TabFlex,
  DriveTableDiv,
} from 'modules/Roles/ViewRole/TwoDriveDrawer/style'
import TwoDriveTable from 'modules/Roles/ViewRole/TwoDriveDrawer/TwoDriveTable/index'
import { useParams } from 'react-router-dom'

const TwoDrivesDrawer = ({
  twoDrivesDrawer,
  setTwoDriveDrawer,
  driveListLoading,
  driveList,
  driveModeFilter,
  setDriveModeFilter,
  pageLimit,
  setPageNum,
  getDriveRoleMetrics,
  driveRoleMetrics,
  getRoleAppliedDriveMetrics,
  roleAppliedDriveMetrics,
}) => {
  const params = useParams()
  const [cardsData, setCardsData] = useState([])
  const [activeKey, setActiveKey] = useState('all')

  useEffect(() => {
    if (twoDrivesDrawer) {
      getRoleAppliedDriveMetrics(params?.jobId)
    }
  }, [twoDrivesDrawer, params])

  useEffect(() => {
    const cardInfo = [
      {
        key: 1,
        text: 'All',
        icon: <Internship />,
        value: roleAppliedDriveMetrics?.totalDriveCount,
        state: 'all',
      },
      {
        key: 2,
        text: 'Campus Drive',
        icon: <Internship />,
        value: roleAppliedDriveMetrics?.campusDriveCount,
        state: 'CAMPUS_DRIVE',
      },
      {
        key: 3,
        text: 'Pool Drive',
        icon: <Internship />,
        value: roleAppliedDriveMetrics?.poolDriveCount,
        state: 'POOL_DRIVE',
      },
      {
        key: 4,
        text: 'Virtual Drive',
        icon: <Internship />,
        value: roleAppliedDriveMetrics?.virtualDriveCount,
        state: 'VIRTUAL_DRIVE',
      },
    ]

    setCardsData(cardInfo)
  }, [roleAppliedDriveMetrics])

  const handleOnTabChange = key => {
    setPageNum(1)
    if (key == 'all' || key == driveModeFilter) {
      setDriveModeFilter('')
      setActiveKey('all')
    } else {
      setDriveModeFilter(key)
      setActiveKey(key)
    }
  }

  const content = () => {
    return (
      <>
        <CardRow>
          {cardsData?.map(card => (
            <InfoCards
            padding={'15px 18px'}
              key={card?.key}
              width={'23%'}
              height="130px"
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
              state={card?.state}
              current={activeKey}
              onClick={() => handleOnTabChange(card?.state)}

              
            />
          ))}
        </CardRow>
        <DriveTableDiv>
          <TabFlex>
            <StyledTabs
              onChange={handleOnTabChange}
              width="100%"
              defaultActiveKey="all"
              activeKey={activeKey}
              textColor={COLORS.PRIMARY}
              headerpadding={'0 25px'}
              bgcolor={'none'}
              items={[
                {
                  label: `All Drives`,
                  key: 'all',
                },
                {
                  label: `Campus Drives`,
                  key: 'CAMPUS_DRIVE',
                },
                {
                  label: `Pool Drives`,
                  key: 'POOL_DRIVE',
                },
                {
                  label: `Virtual Drives`,
                  key: 'VIRTUAL_DRIVE',
                },
              ]}
            />
          </TabFlex>
          <TwoDriveTable
            loading={driveListLoading}
            driveList={driveList}
            pageLimit={pageLimit}
            setPageNum={setPageNum}
            getDriveRoleMetrics={getDriveRoleMetrics}
            driveRoleMetrics={driveRoleMetrics}
            setTwoDriveDrawer={setTwoDriveDrawer}
          />
        </DriveTableDiv>
      </>
    )
  }

  return (
    <Drawer
      width="65%"
      height="98%"
      title={`${roleAppliedDriveMetrics?.totalDriveCount} Drives(s) Created`}
      placement="right"
      visible={twoDrivesDrawer}
      content={content()}
      onClose={() => {
        setTwoDriveDrawer(false)
      }}
      closable={true}
    />
  )
}

export default TwoDrivesDrawer
